import { BaseListItem } from '@did/das-balance-components'
import { IDidPointRecord } from '@did/types'
import { formatDateTime, getActionSymbol, thousandSplit } from '@did/tools'
import React from 'react'
import styles from './history-item.module.scss'
import TrxAction from './trx-action'
import { useDasBalanceContext } from '@did/das-app-context'
import { FIAT_DECIMAL_PLACES } from '@did/constants'
import { Iconfont } from '@did/uikit'

interface HistoryItemProps {
  recordInfo: IDidPointRecord
}

export const HistoryItem: React.FC<HistoryItemProps> = ({ recordInfo }) => {
  const { router } = useDasBalanceContext()

  const goRecordPage = () => {
    router.push('/credits/record', {
      orderId: recordInfo.order_id,
      recordId: recordInfo.record_id
    })
  }

  return (
    <BaseListItem
      className={styles.historyItem}
      onClick={goRecordPage}
      head={
        <div className={styles.historyItem__header}>
          <span className={styles.historyItem__header__priceCkb}>
            <span
              className={
                getActionSymbol(recordInfo.action_dp) === '+'
                  ? styles.historyItem__header__actionReceipt
                  : styles.historyItem__header__actionPay
              }
            >
              {getActionSymbol(recordInfo.action_dp) +
                ' ' +
                thousandSplit(recordInfo.amount_dp, FIAT_DECIMAL_PLACES)}
              <span className="text-[#636D85] text-base font-normal ml-1">
                Credits
              </span>
            </span>
            <Iconfont name="arrow-right" color="#ACB9D9" size="13" />
          </span>
          <span className={styles.historyItem__header__timestamp}>
            {formatDateTime(recordInfo.timestamp)}
          </span>
        </div>
      }
      tail={<TrxAction recordInfo={recordInfo} />}
    />
  )
}
